import {
  EyeOutlined,
  PrinterOutlined,
  DollarOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { Button, Popconfirm, Space, Tooltip } from "antd";
import React from "react";
import "./OrderActions.scss";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import OrderService from "services/order";
import PrintOrderButton from "components/PrintOrderButton";

const OrderActions = ({ record, refetch }) => {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const updateOrderStatus = async (newStatus) => {
    try {
      await OrderService.updateOrder({
        id: record?.orderId,
        data: {
          orderStatus: newStatus,
          note: " ",
        },
      });
      refetch();
    } catch (error) {}
  };

  const updateOrderPaymentStatus = async (newStatus) => {
    try {
      await OrderService.updateOrder({
        id: record?.orderId,
        data: {
          paymentStatus: newStatus,
          note: " ",
        },
      });
      refetch();
    } catch (error) {}
  };
  return (
    <Space size="small">
      <Tooltip title={translate("order.view")} placement="top">
        <Button
          type="text"
          icon={<EyeOutlined className="action-icon view" />}
          className="action-button"
          onClick={() => history.push(`/order-detail/${record?.orderId}`)}
        />
      </Tooltip>
      <PrintOrderButton
        orderId={record?.orderId}
        showText={false}
        buttonType="text"
      />
      {/* <Tooltip title={translate("order.print")} placement="top">
        <Button
          type="text"
          icon={<PrinterOutlined className="action-icon print" />}
          className="action-button"
        />
      </Tooltip> */}
      {record?.paymentStatus !== "Success" && record?.orderStatus !== 20 && (
        <Tooltip title={translate("order.pay")} placement="top">
          <Button
            type="text"
            icon={<DollarOutlined className="action-icon pay" />}
            className="action-button"
            onClick={() => {
              localStorage.setItem('pendingOrderId', record?.orderId);
              history.push('/orders?tab=1&payment=true');
            }}
          />
        </Tooltip>
      )}
      {record?.orderStatus !== 20 && (
        <Popconfirm
          title="Bạn có chắc chắn muốn huỷ đơn hàng này?"
          onConfirm={() => updateOrderStatus(20)}
          okText="Có"
          cancelText="Không"
        >
          <Tooltip title={translate("order.cancel")} placement="top">
            <Button
              type="text"
              icon={<CloseOutlined className="action-icon cancel" />}
              className="action-button"
              danger
            />
          </Tooltip>
        </Popconfirm>
      )}
    </Space>
  );
};

export default OrderActions;
